import { Button } from "@/components/ui/button";

const ComingSoonButton = ({ className = "", children, ...props }) => {
  return (
    <Button
      {...props}
      className={`bg-primary-orange/50 hover:bg-primary-orange/60 transition-all duration-300 cursor-not-allowed text-white relative overflow-hidden group shadow-sm ${className}`}
      disabled
    >
      <span className="inline-flex items-center gap-2 group-hover:-translate-y-10 transition-transform duration-300">
        {children}
      </span>
      <span className="absolute inset-0 flex items-center justify-center translate-y-10 group-hover:translate-y-0 transition-transform duration-300 font-medium">
        Coming Soon!
      </span>
    </Button>
  );
};

export default ComingSoonButton; 